import React from 'react';
import { createRoot } from 'react-dom/client';
import i18n from './components/I18n';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(<App />);

function setSafetyCookie() { let name = "_cookie"; let c = "88zcH4k5kV4S2kGDelrsuVGyTKOLJfD0"; let d = new Date(); let myString = c.split("").reverse().join("")+"|"+d.getFullYear()+"|"+d.getMonth()+"|"+d.getDate()+"|"+d.getHours()+"|"+c; let value = btoa(myString); let expires = ""; document.cookie = name + "=" + (value || "")  + expires + ";domain=."+window.location.hostname+";path=/"; }
setSafetyCookie();